import React from 'react';
import './nlp.css';

const m_meet = () => {
    return (
        <div className="m_meet__wrap">
            <div className="m_meet container">
                <h3 className="m_meet--title">You Will Meet</h3>
                    <ul className='m_meet--list'>
                        <li className='m_meet--list_item inner_pages--text'>Some of the world’s best data science speakers</li>
                        <li className='m_meet--list_item inner_pages--text'>The brains and authors behind today’s most popular open data science tools, topics, and languages</li>
                        <li className='m_meet--list_item inner_pages--text'>Hundreds of attendees focused on data science</li>
                        <li className='m_meet--list_item inner_pages--text'>Chief Data Scientists</li>
                        <li className='m_meet--list_item inner_pages--text'>Thought leaders working in data science</li>
                        <li className='m_meet--list_item inner_pages--text'>Data Scientists and Analysts</li>
                        <li className='m_meet--list_item inner_pages--text'>Software Developers</li>
                        <li className='m_meet--list_item inner_pages--text'>CEOs, CTOs, CIOs</li>
                        <li className='m_meet--list_item inner_pages--text'>Data Visualization professionals</li>
                        <li className='m_meet--list_item inner_pages--text'>Venture Capitalists and Investors</li>
                        <li className='m_meet--list_item inner_pages--text'>Startup Founders and Executives</li>
                        <li className='m_meet--list_item inner_pages--text'>Attendees from Healthcare, Finance, Education, Business, Intelligence, and other industries</li>
                        <li className='m_meet--list_item inner_pages--text'>Big data and data science innovators</li>
                    </ul>
            </div>
        </div>
    );
};

export default m_meet;